import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "linkedin-inverse",
  "use": "linkedin-inverse-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"linkedin-inverse\">\n    <path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M3.259 4.866v8.848H.313V4.866h2.946zm.187-2.732c.006.434-.144.798-.45 1.09-.307.29-.71.437-1.21.437h-.018c-.488 0-.881-.146-1.179-.438a1.463 1.463 0 0 1-.446-1.09c0-.44.153-.804.46-1.093.306-.289.707-.433 1.2-.433.495 0 .89.144 1.188.433.298.289.45.653.455 1.094zm4.375 3.99c.114-.18.23-.336.349-.472.125-.143.293-.298.504-.465a2.32 2.32 0 0 1 .777-.388 3.54 3.54 0 0 1 1.022-.138c1.018 0 1.837.338 2.456 1.013.619.676.928 1.665.928 2.969v5.071H10.92V8.982c0-.625-.12-1.114-.362-1.469-.241-.354-.618-.53-1.13-.53-.374 0-.688.102-.941.307-.253.206-.442.46-.567.764-.066.178-.099.42-.099.723v4.937H4.884c.012-2.375.018-4.3.018-5.777 0-1.476-.003-2.357-.01-2.642l-.008-.429H7.82v1.257z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/linkedin-inverse.svg
// module id = ./src/assets/img/linkedin-inverse.svg
// module chunks = 4